import { IonChip } from '@ionic/react'
import { useState } from 'react'

import { tap } from '../../lib/native'

import { Composer } from './Composer'
import type { DockProps } from './StepDock'

/**
 * A question, matched against the business's own approved answers.
 *
 * The business's questions are offered as suggestion chips above the composer
 * — the pattern every assistant app uses for "here is what I can answer". An
 * empty box asking "what would you like to know?" gives a customer no idea
 * what this business can actually answer, and the answerable set is small and
 * already written down. Tapping one sends the row id, so the matcher never
 * runs: no model call, no latency, no chance of landing on the wrong row.
 *
 * The composer stays, because a question nobody predicted is exactly what the
 * matcher is for.
 */
export function FaqDock({ view, busy, onSend }: DockProps) {
  const [question, setQuestion] = useState('')

  return (
    <div className="blooq-walk">
      {view.options.length > 0 ? (
        <div className="blooq-suggest" role="group" aria-label="Common questions">
          {view.options.map((option) => (
            <IonChip
              key={option.value}
              className="blooq-chip"
              disabled={busy}
              role="button"
              onClick={() => {
                tap()
                onSend({ faqId: option.value }, option.label)
              }}
            >
              {option.label}
            </IonChip>
          ))}
        </div>
      ) : null}

      {view.errors?.question ? <p className="blooq-err">{view.errors.question}</p> : null}

      <Composer
        value={question}
        onChange={setQuestion}
        onSubmit={() => {
          tap()
          onSend({ question: question.trim() }, question.trim())
        }}
        placeholder="Ask anything…"
        kind="question"
        maxlength={500}
        disabled={busy}
        ready={question.trim().length >= 3}
      />
    </div>
  )
}
